import React from 'react'
import PropTypes from 'prop-types'
import { RadioGroup, ScrollErrorForm } from 'components'
import { FlowActions } from '../../../benefit-distributions/components'
import { AccountAudience } from 'config/portal'
import { SigningMethod, signingMethodOptions } from 'config/automatic-rollovers'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Icon as WetSignatureIcon } from 'images/signing-method-icons/wet-signature-new.svg'
import { Icon as ElectronicSignatureIcon } from 'images/signing-method-icons/electronic-signature-new.svg'

const propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  accountAudience: PropTypes.oneOf(Object.values(AccountAudience)).isRequired,
}

const defaultProps = {
  initialValues: {},
}

function getSigningMethodIcon(method) {
  switch (method) {
    case SigningMethod.ELECTRONIC_SIGNATURE:
      return ElectronicSignatureIcon
    case SigningMethod.WET_SIGNATURE:
      return WetSignatureIcon
    default:
      return () => null
  }
}

function SigningMethodLabel({ htmlFor, option }) {
  const SignatureIcon = getSigningMethodIcon(option.key)
  return (
    <label htmlFor={htmlFor}>
      <div className="icon-container">
        <SignatureIcon aria-hidden="true" />
      </div>
      <div className="description-container">
        <p className="label">{option.key}</p>
        <p className="description">{option.description}</p>
      </div>
    </label>
  )
}

const signingMethods = signingMethodOptions.filter(
  (option) => option.key !== SigningMethod.E_SIGN_RSP
)
const signingMethodValues = signingMethods.map((option) => option.value)

function SelectSignaturePreferenceForm({
  initialValues,
  onSubmit,
  accountAudience,
}) {
  const validationSchema = Yup.object().shape({
    signingMethod: Yup.lazy(() => {
      if (accountAudience === AccountAudience.PLAN_FIDUCIARY)
        return Yup.string().nullable()
      return Yup.string()
        .oneOf(signingMethodValues, 'Must be a valid signing method')
        .required('Select a signature option')
    }),
  })

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => onSubmit(values)}
    >
      {() => {
        return (
          <ScrollErrorForm>
            {accountAudience !== AccountAudience.PLAN_FIDUCIARY && (
              <div className="form-column full-row">
                <RadioGroup
                  className="card-radio-group"
                  name="signingMethod"
                  label="How would you like to sign?"
                  options={signingMethods}
                  radioInputProps={{
                    labelComponent: SigningMethodLabel,
                  }}
                />
              </div>
            )}
            <FlowActions />
          </ScrollErrorForm>
        )
      }}
    </Formik>
  )
}

SelectSignaturePreferenceForm.propTypes = propTypes
SelectSignaturePreferenceForm.defaultProps = defaultProps

export default SelectSignaturePreferenceForm
